const icons = {
  contacts: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-user"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
      <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
    </svg>
  ),
  // team: (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="20"
  //     height="20"
  //     fill="currentColor"
  //     className="bi bi-people"
  //     viewBox="0 0 16 16"
  //   >
  //     <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
  //   </svg>
  // ),
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const Contacts = {
  id: "contact-list",
  title: "Contacts",
  role: [0,1,2],
  type: "group",
  children: [
    {
      id: "/contact-list",
      title: "Contact List",
      type: "item",
      url: "/contact-list",
      icon: icons.contacts,
      role: [0,1,2],
      breadcrumbs: false,
    },
    // {
    //   id: "/team-list",
    //   title: "Team List",
    //   type: "item",
    //   url: "/team-list",
    //   icon: icons.team,
    //   breadcrumbs: false,
    // },
  ],
};

export default Contacts;
